module.exports = __webpack_public_path__ + "static/img/right-total-line.97d0458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/right-total-line.png
// module id = G4o9
// module chunks = 9